import React from "react";

import { ListItem, ListItemText } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";

export default function CustomerGroupExportSkeleton() {
  const classes = useStyles();

  return (
    <>
      <ListItem className={classes.exportListItem}>
        <ListItemText
          primary={<Skeleton variant="text" width={200} height={24} />}
          secondary={<Skeleton variant="text" width={260} height={16} />}
          className={classes.exportListItemText}
        />
        <Skeleton variant="rect" width={96} height={32} />
        <div className={classes.skeletonButtonsContainer}>
          <Skeleton
            variant="circle"
            width={36}
            height={36}
            className={classes.skeletonButton}
          />
          <Skeleton
            variant="circle"
            width={36}
            height={36}
            className={classes.skeletonButton}
          />
        </div>
      </ListItem>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    skeletonButtonsContainer: {
      paddingLeft: 16,
      marginRight: -8,
      display: "flex",
    },
    skeletonButton: {
      margin: 4,
    },
    exportListItem: {
      justifyContent: "space-between",
      cursor: "auto",
      userSelect: "auto",
    },
    exportListItemText: {
      minWidth: 280,
      marginRight: 16,
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroup/CustomerGroupExport/CustomerGroupExportSkeleton.tsx